import * as actions from './actions';
import { TOGGLE_PROJECT_STATE } from '../../mutation-types';
import { MOBILE_SWITCHER_STATES } from './helpers';

const mutations = {
    [TOGGLE_PROJECT_STATE](state, { id, value }) {
        state[id] = value;
    },
};

/** @type {IProjectStatusState} */
const state = {
    menuSidebar: false,
    mobileSwitcher: MOBILE_SWITCHER_STATES.LIST,
};

export default {
    namespaced: true,
    mutations,
    actions,
    state,
};
